import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import RedditActions from '../../Redux/RedditRedux'

class SecondaryScreen extends Component {
  render() {
    return (
      <div style={styles.container}>
        Second Screen!
        <button
          style={styles.button}
          onClick={() => this.props.history.push('/LoggedInHome')}
        >
          Go to Home Screen
        </button>
        <button style={styles.button} onClick={this.props.getShowerThought}>
          Random Shower Thought?
        </button>
        <div style={styles.textContainer}>
          {this.props.reddit.showerThought || this.props.reddit.error}
        </div>
      </div>
    )
  }
}

function mapStateToProps(reduxState, props) {
  const { reddit } = reduxState
  return { reddit }
}

// wraps dispatch to create nicer functions to call within our component
const mapDispatchToProps = dispatch => ({
  getShowerThought: () => dispatch(RedditActions.showerThoughtRequest()),
})

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(SecondaryScreen),
)

const styles = {
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    flexDirection: 'column',
  },
  button: {
    marginTop: 50,
    marginBottom: 50,
    padding: 12,
    backgroundColor: 'tomato',
    borderRadius: 4,
  },
  textContainer: {
    marginHorizontal: 12,
    textAlign: 'center',
  },
}
